import { SelectedMedia } from '@/lib/model';

export function getVideoJSType(media: SelectedMedia) {
  return (
    ([
      'application/x-www-form-urlencoded',
      'application/octet-stream',
      'application/vnd.apple.mpegurl',
    ].includes(media?.media?.mimeType || '')
      ? 'video/mp4'
      : media?.media?.mimeType) ?? 'application/x-mpegURL'
  );
}
